var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7324 6.64206C10.5541 6.45643 10.3378 6.36369 10.083 6.36369H9.77764V4.45449C9.77764 3.23482 9.35761 2.18756 8.51728 1.31256C7.67702 0.43752 6.67141 0 5.49995 0C4.32852 0 3.32271 0.43752 2.48252 1.31252C1.64219 2.18756 1.22216 3.23478 1.22216 4.45449V6.36369H0.916647C0.662101 6.36369 0.445615 6.45643 0.267355 6.64206C0.0890962 6.82754 0 7.05297 0 7.31828V13.0455C0 13.3105 0.0891296 13.536 0.267355 13.7217C0.445615 13.9072 0.662101 14 0.916647 14H10.0833C10.338 14 10.5543 13.9073 10.7326 13.7217C10.9107 13.536 11 13.3105 11 13.0455V7.31817C11.0001 7.05307 10.9107 6.82768 10.7324 6.64206ZM7.94438 6.36369H3.05552V4.45449C3.05552 3.75188 3.29428 3.15193 3.7717 2.65486C4.24919 2.15772 4.82524 1.9092 5.50005 1.9092C6.17493 1.9092 6.75084 2.15768 7.22836 2.65486C7.70565 3.1519 7.94438 3.75188 7.94438 4.45449V6.36369Z",
    fill: "#CCCCCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.2e1981eb08a2791612f80818f01f4b3c.svg";
export { ForwardRef as ReactComponent };